import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    headerLabel: {
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
    },
    headerLabelSingle: {
      color: theme.palette.general.grey70,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
    },
    inlineLabel: {
      alignItems: 'center',
      display: 'flex',
      lineHeight: 1,
      textAlign: 'center',
    },
    headerSubLabel: {
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    reserved: {
      color: theme.palette.primary.main,
    },
    late: {
      color: theme.palette.error.main,
    },
    searchIcon: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
    },
    paper: {
      boxShadow: '0px 3px 6px #0000001A',
    },
    helpIconInline: {
      fontSize: '0.875rem',
      color: theme.palette.general.grey70,
      marginLeft: 2,
    },
    columnHeader: {
      display: 'flex',
      flexDirection: 'column',
    },
    columnHeaderInline: {
      display: 'flex',
      height: 15,
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
  };
});

const CardStyles = makeStyles({
  root: {
    padding: 0,
    paddingBottom: '0 !important',
  },
});

export { useStyles, CardStyles };
